<template>
    <div class="world-map">
        <div ref="worldMap" class="map-wrap" id="worldMap"></div>
    </div>
</template>

<script>
// import "echarts/map/js/china";
import * as echarts from 'echarts';
let appData = require("../assets/json/continent_geo.json");
export default {
    name: "worldMap",
    components: {},
    props: {
        data: {
            type: Array,
        },
        title: {
            type: Object,
        },
        pieces: {
            type: Array,
            default: () => {
                return [
                    // 自定义每一段的范围，以及每一段的文字
                    { lte: 0, label: "0" }, // 不指定 min，表示 min 为无限大（-Infinity）。
                    { gte: 1, lte: 100, label: "1-100" },
                    { gte: 101, lte: 500, label: "101-500" },
                    { gte: 501, label: ">=500(单位: 万美元)" }, // 不指定 max，表示 max 为无限大（Infinity）。
                ];
            },
        },
    },
    watch: {
        data: {
            handler: function () {
                this.initMap();
            },
            deep: true,
        },
    },
    data() {
        return {
            myChart: null,
        };
    },
    activated() {
        // 这是再keep-alive 缓存条件下的 从另外一个页面跳转到当前页面的 地图进行自适应
        if (this.myChart) {
            setTimeout(() => {
                this.myChart.resize();
            }, 200);
        }
    },
    methods: {
        initMap() {
            echarts.registerMap("continent", appData);
            this.myChart = echarts.init(document.getElementById("worldMap"));
            this.myChart.setOption({
                title: {
                    top: 10,
                    subtext: "",
                    x: "center",
                    textStyle: {
                        color: "#1A1A1E",
                    },
                },
                tooltip: {
                    trigger: "item",
                    formatter: function (params) {
                        let dom = `
                            <div> ${params.data.name} </div>
                            <div>成员数量： ${params.data.value} </div>
                        `;
                        return dom;
                    },
                },
                // visualMap: {
                //     bottom: "6%",
                //     left: "1%",
                //     textStyle: { color: "#73747E" },
                //     pieces: this.pieces,
                //     inRange: {
                //         渐变颜色，从小到大
                //         color: ["#8CBB4B", "#133891", "#F2853E", "#E82323"],
                //     },
                // },
                series: [
                    {
                        type: "map",
                        mapType: "continent", // 自定義擴展圖表類型
                        zoom: 1.1,
                        aspectScale: 1.1, //长宽比
                        itemStyle: {
                            normal: { label: { show: false }, },
                            emphasis: { label: { show: true },areaColor: "#0FAB5D", },
                        },
                        data: this.data,
                    },
                ],
            });
        },
    },
    mounted() {
        this.initMap();
    },
};
</script>
<style lang="scss" scoped>
.world-map {
    width: 100%;
    height: 100%;

    .map-wrap {
        width: 100%;
        height: 100%;
    }
}
</style>